import { render } from "./ArchivedTasks.vue?vue&type=template&id=197ab223&scoped=true"
import script from "./ArchivedTasks.vue?vue&type=script&lang=js"
export * from "./ArchivedTasks.vue?vue&type=script&lang=js"

import "./ArchivedTasks.vue?vue&type=style&index=0&id=197ab223&scoped=true&lang=scss"

import exportComponent from "/home/tabelka-front/tabelka.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197ab223"]])

export default __exports__